import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute, Router } from '@angular/router';
import { acceptedFileTypes } from 'app-models';
import { FileUploadLibraryService } from 'file-upload-library';
import { ToastrService } from 'ngx-toastr';
import { Subject } from 'rxjs';
import { take, takeUntil } from 'rxjs/operators';
import { LcaService } from 'src/app/services/lca.service';
import { UploadDocumentService } from 'src/app/services/upload-document.service';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'app-update-decision',
    templateUrl: './update-decision.component.html',
    styleUrls: ['./update-decision.component.scss']
})
export class UpdateDecisionComponent implements OnInit {
    lcaDetails: any;
    destroy$ = new Subject();
    originUrl: string;

    displayedColumns: string[] = ['caseNumber', 'socTitle', 'socCode', 'employmentStartDate', 'employmentEndDate', 'companyName', 'visaType', 'notes', 'status'];
    dataSource = new MatTableDataSource<any>([]); // Initialize with an empty MatTableDataSource

    lcaForm: FormGroup;

    workForceConfigurations = {
        inputMultipleFlag: false,
        fileType: acceptedFileTypes,
        isFileListRequired: true,
        categoryName: 'LCAWRKFRCNOTF',
        entityId: 0,
        fileCategory: 'LCA',
        listUploadedFiles: [],
        documentTypeRequired: false,
        docummentTypeCode: 'LCAWRKFRCNOTF',
        useCase: 'company',
        useCaseId: parseInt(sessionStorage.getItem('companyId')),
        useEntityId: false,
        isUploadEnabled: true
    };

    configurations = {
        inputMultipleFlag: false,
        fileType: acceptedFileTypes,
        isFileListRequired: true,
        categoryName: 'LCADOC',
        entityId: 0,
        fileCategory: 'LCA',
        listUploadedFiles: [],
        documentTypeRequired: true,
        docummentTypeCode: 'LCADOC',
        useCase: 'company',
        useCaseId: parseInt(sessionStorage.getItem('companyId')),
        useEntityId: false
    };



    cerifiedLcaConfigurations = {
        inputMultipleFlag: false,
        fileType: acceptedFileTypes,
        isFileListRequired: true,
        categoryName: 'LCADOC',
        entityId: 0,
        fileCategory: 'LCA',
        listUploadedFiles: [],
        documentTypeRequired: false,
        docummentTypeCode: '',
        useCase: 'company',
        useCaseId: parseInt(sessionStorage.getItem('companyId')),
        useEntityId: false
    };
    lcaId: any;

    constructor(
        private lcaService: LcaService,
        private router: Router,
        private route: ActivatedRoute,
        private fb: FormBuilder,
        private uploadDocumentService: UploadDocumentService,
        public uploadService: FileUploadLibraryService,
        private toastr: ToastrService
    ) {

        const navState = this.router.getCurrentNavigation();

        this.originUrl = (navState.extras && navState.extras.state && navState.extras.state.redirectUrl) ? navState.extras.state.redirectUrl : '';
        this.originUrl = this.originUrl == '' ? '../lca' : this.originUrl; //fall back to list page 
        if (sessionStorage.getItem('originPage') && sessionStorage.getItem('originUrl')) {
            this.originUrl = sessionStorage.getItem('originUrl');
        }
    }

    ngOnInit(): void {
        if (sessionStorage.getItem("lcaId") !== null) {
            this.lcaService.getEFileDetails(parseInt(sessionStorage.getItem("lcaId"))).pipe(takeUntil(this.destroy$)).subscribe((response) => {
                if (response) {
                    this.lcaDetails = response;
                    console.log(this.lcaDetails, 1234);
                    this.dataSource.data = [this.lcaDetails.lcaApplication];
                }
            });
        }
        this.lcaId = sessionStorage.getItem('lcaId') ? parseInt(sessionStorage.getItem('lcaId')) : null;
        this.cerifiedLcaConfigurations.entityId = this.lcaId;
        this.cerifiedLcaConfigurations = Object.assign({}, this.cerifiedLcaConfigurations);

        this.configurations.entityId = this.lcaId;
        this.configurations = Object.assign({}, this.configurations);

        this.workForceConfigurations.entityId = this.lcaId;
        this.workForceConfigurations = Object.assign({}, this.workForceConfigurations);

        
        this.lcaForm = this.fb.group({
            decision: ['Certified', Validators.required],
            certificationDate: [''],
            notes: ['', [Validators.required, Validators.maxLength(30)]],  // Added required validator for notes
            workforceNotified: [false, Validators.required],
            workforceNotifiedDate: [''],
        });
        
        // Update validation based on decision value
        this.lcaForm.get('decision').valueChanges.subscribe(value => {
            const certificationDateControl = this.lcaForm.get('certificationDate');
            if (value === 'Certified') {
                certificationDateControl.setValidators(Validators.required);
            } else {
                certificationDateControl.clearValidators();
                certificationDateControl.reset();
            }
            certificationDateControl.updateValueAndValidity();
        });
        
        // Update validation based on workforceNotified switch
        this.lcaForm.get('workforceNotified').valueChanges.subscribe(isNotified => {
            const workforceNotifiedDateControl = this.lcaForm.get('workforceNotifiedDate');
            if (isNotified) {
                workforceNotifiedDateControl.setValidators(Validators.required);
            } else {
                workforceNotifiedDateControl.clearValidators();
                workforceNotifiedDateControl.reset();
            }
            workforceNotifiedDateControl.updateValueAndValidity();
        });
        this.getUpolodedFiles();
        this.getWorkForceUpolodedFiles();
    }

    backToOriginPage() {
        if (this.originUrl?.includes('immigration-wizard')) {
            this.router.navigate([`${this.originUrl}`]);
        } else {
            this.router.navigate([`${this.originUrl}`], { relativeTo: this.route });
        }
    }

    onCancel(): void {
        this.lcaForm.reset();
        this.backToOriginPage();
    }

    onSubmit(): void {
        const payload = {
            isCertifiedLCA: this.lcaForm.get('decision').value == 'Certified' ? true : false,
            notes: this.lcaForm.get('notes').value,
            certifiedDate: new Date(this.lcaForm.get('certificationDate').value),
            statusChangeDate: new Date(),
            workforceNotifiedDate: new Date(this.lcaForm.get('workforceNotifiedDate').value),
            isWorkforceNotified: this.lcaForm.get('workforceNotified').value,
        }
        if (this.lcaForm.valid) {
            this.lcaService.updateLcaDecision(parseInt(sessionStorage.getItem("lcaId")), payload).pipe(takeUntil(this.destroy$)).subscribe((response) => {
                if (response) {
                    this.toastr.success(response['message']);
                    this.backToOriginPage();
                }
            });
        }
    }

    getWorkForceUpolodedFiles() {
        this.uploadDocumentService.genericGetUploadDocument(this.workForceConfigurations.useCase, this.workForceConfigurations.useCaseId, this.workForceConfigurations.categoryName, this.workForceConfigurations.entityId, this.workForceConfigurations.useEntityId).pipe(take(1)).subscribe((response) => {
            if (response['status'] === 200) {
                this.workForceConfigurations.listUploadedFiles = response['data'];
                this.workForceConfigurations = Object.assign({}, this.workForceConfigurations);
            }
            else {
                this.workForceConfigurations.listUploadedFiles = [];
                this.workForceConfigurations = Object.assign({}, this.workForceConfigurations);
            }
        });
    }

    getUpolodedFiles() {
        this.uploadDocumentService.genericGetUploadDocument(this.configurations.useCase, this.configurations.useCaseId, this.configurations.categoryName, this.configurations.entityId, this.configurations.useEntityId).pipe(take(1)).subscribe((response) => {
            if (response['status'] === 200) {
                this.configurations.listUploadedFiles = response['data'];
                this.configurations = Object.assign({}, this.configurations);
            }
            else {
                this.configurations.listUploadedFiles = [];
                this.configurations = Object.assign({}, this.configurations);
            }
        });
    }

    downloadFile(file) {
        this.uploadService.downloadDocuments(environment.docs + file.substring(22), file.substring(22));
    }
}
